import { observable, action, computed } from "mobx";
import { api } from "../services";

class UsersStore {
  @observable users = [];
  @observable filterForPending = '';

  @action
  load() {
    return api({ action: "get users" }).then(users => {
      if (users) this.users = users.users;
      else this.users = [];
    });
  }

  @action
  addOrModify(user) {
    if (user) {
      const userIndex = this.users.findIndex(u => u._id === user._id);
      if (userIndex === -1) {
        this.users.push(user);
      } else {
        this.users[userIndex] = user;
      }
    }
  }

  @computed
  get all() {
    return this.users.filter(u => u.assets[0].subscription.status > 6.2);
  }

  @computed
  get clients() {
    return this.users.filter(u => u.assets[0].subscription.status >= 6.2);
  }

  @computed
  get pending() {
    return this.users.filter(u => u.assets[0].subscription.status < 6.3);
  }

  setPendingFileter(query){
    this.filterForPending = query;
  }

  @computed
  get pendingFiltered() {
    if(this.filterForPending === ''){
      return this.users.filter(u => u.assets[0].subscription.status < 6.3);
    }
    return (this.users.filter(u => u.assets[0].subscription.status < 6.3)).filter(user => {
      const {
        assets: [
          {
            imei,
            car: { plate }
          }
        ],
        ragsoc = '',
        firstname = '',
        lastname = ''
      } = user;
      const name = `${firstname} ${lastname}`.trim();
      return (
        name.toLowerCase().includes(this.filterForPending.toLowerCase()) ||
        ragsoc.toLowerCase().includes(this.filterForPending.toLowerCase()) ||
        plate.toLowerCase().includes(this.filterForPending.toLowerCase()) ||
        imei.toLowerCase().includes(this.filterForPending.toLowerCase())
      );
    });
  }

}

export default new UsersStore();



// WEBPACK FOOTER //
// ./src/stores/usersStore.js